import actions from "./actions";
import dynamic_issues_blocks from "./dynamic_issues_blocks";
import blocks from "./blocks";
import tabs from "./tabs";
import form_data from "./form";
import percentage from "./percentage";
import dynamic_issues_print_card from "./print/dynamic_issues_print_card";
import print_card from "./print/print_card";
import completion_certificate from "./print/print_completion_certificate";
import print_equipment_tech_map from "../../view/ppr/equipments/show/tech_map/print/print_equipment_tech_map";

export default {
  actions: actions,
  dynamic_issues_blocks: dynamic_issues_blocks,
  blocks: blocks,
  tabs: tabs,
  form_data: form_data,
  percentage: percentage,
  dynamic_issues_print_card: dynamic_issues_print_card,
  print_card: print_card,
  completion_certificate: completion_certificate,
  print_equipment_tech_map: print_equipment_tech_map,
};
